import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, } from 'react';
import clsx from 'clsx';
import { Snackbar, IconButton, SnackbarContent, makeStyles, } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Report';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
const useStyle = makeStyles((theme) => {
    return {
        content: {
            flexWrap: 'nowrap',
        },
        info: {
            backgroundColor: theme.palette.info.main,
            color: theme.palette.info.contrastText,
        },
        success: {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
        },
        warning: {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.warning.contrastText,
        },
        error: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
        icon: {
            fontSize: 20,
        },
        iconVariant: {
            opacity: 0.9,
            marginRight: theme.spacing(1),
        },
        message: {
            display: 'flex',
            alignItems: 'center',
        },
    };
}, {
    name: 'Notification',
});
/**
 * This is a component in charge of displaying notification using Material UI Snackbar.
 */
export var NotifType;
(function (NotifType) {
    NotifType["INFO"] = "info";
    NotifType["SUCCESS"] = "success";
    NotifType["WARNING"] = "warning";
    NotifType["ERROR"] = "error";
})(NotifType || (NotifType = {}));
const variantIcon = {
    [NotifType.INFO]: InfoIcon,
    [NotifType.SUCCESS]: CheckCircleIcon,
    [NotifType.WARNING]: WarningIcon,
    [NotifType.ERROR]: ErrorIcon,
};
export const NotificationBar = (props) => {
    const alertType = props.type;
    const duration = props.duration !== undefined && props.duration > 0 ? props.duration : 5000;
    const Icon = variantIcon[alertType];
    const classes = useStyle();
    /**
     * Translate the values of the title, message, button' data before we pass it to interpolation
     */
    const translatedMessage = useMemo(() => {
        const { translate } = props;
        if (props.message && translate) {
            // if there is 'messageData', translate the messageData' fields first
            const translatedData = props.messageData
                ? Object.entries(props.messageData).reduce((result, entry) => {
                    const [key, value] = entry;
                    return {
                        ...result,
                        [key]: (typeof value === 'string') ? translate(value) : value,
                    };
                }, {})
                : {};
            // Now translate the message and pass the translatedData as interpolation
            return translate(props.message, translatedData);
        }
        // there is no translator, show the message as is if there is one
        return props.message;
    }, [props]);
    const handleClose = useCallback(() => {
        props.onClose();
    }, [props]);
    return (_jsx("div", { children: _jsx(Snackbar, { anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, open: true, autoHideDuration: duration, onClose: handleClose, children: _jsx(SnackbarContent, { className: clsx(classes.content, classes[alertType]), message: (_jsxs("span", { id: "client-snackbar", className: classes.message, children: [_jsx(Icon, { className: clsx(classes.icon, classes.iconVariant) }), _jsx("span", { id: "message-id", children: translatedMessage })] })), action: [
                    _jsx(IconButton, { color: "inherit", onClick: handleClose, children: _jsx(CloseIcon, { className: classes.icon }) }, "close"),
                ] }) }) }));
};
